import {NotificationService} from '../services';
import {AutoCapturaService} from '../services';
import {EnvService} from '../services';

/**
 * Action Types
 */
export const GET_ESTADOCIVIL = 'auto-captura/Select/GET_ESTADOCIVIL';
export const GET_ESTADOCIVIL_SUCCESS =
  'auto-captura/Select/GET_ESTADOCIVIL_SUCCESS';
export const GET_ESTADOCIVIL_FAIL = 'auto-captura/Select/GET_ESTADOCIVIL_FAIL';

export const GET_UF = 'auto-captura/Select/GET_UF';
export const GET_UF_SUCCESS = 'auto-captura/Select/GET_UF_SUCCESS';
export const GET_UF_FAIL = 'auto-captura/Select/GET_UF_FAIL';

export const GET_CIDADES = 'auto-captura/Select/GET_CIDADES';
export const GET_CIDADES_SUCCESS = 'auto-captura/Select/GET_CIDADES_SUCCESS';
export const GET_CIDADES_FAIL = 'auto-captura/Select/GET_CIDADES_FAIL';

export const GET_ORGAOSEXPEDIDORES =
  'auto-captura/Select/GET_ORGAOSEXPEDIDORES';
export const GET_ORGAOSEXPEDIDORES_SUCCESS =
  'auto-captura/Select/GET_ORGAOSEXPEDIDORES_SUCCESS';
export const GET_ORGAOSEXPEDIDORES_FAIL =
  'auto-captura/Select/GET_ORGAOSEXPEDIDORES_FAIL';

export const GET_TIPOSPROFISSOES = 'auto-captura/Select/GET_TIPOSPROFISSOES';
export const GET_TIPOSPROFISSOES_SUCCESS =
  'auto-captura/Select/GET_TIPOSPROFISSOES_SUCCESS';
export const GET_TIPOSPROFISSOES_FAIL =
  'auto-captura/Select/GET_TIPOSPROFISSOES_FAIL';

export const GET_PROFISSOES = 'auto-captura/Select/GET_PROFISSOES';
export const GET_PROFISSOES_SUCCESS =
  'auto-captura/Select/GET_PROFISSOES_SUCCESS';
export const GET_PROFISSOES_FAIL = 'auto-captura/Select/GET_PROFISSOES_FAIL';

export const GET_RELACOES = 'auto-captura/Select/GET_RELACOES';
export const GET_RELACOES_SUCCESS = 'auto-captura/Select/GET_RELACOES_SUCCESS';
export const GET_RELACOES_FAIL = 'auto-captura/Select/GET_RELACOES_FAIL';

export const GET_DIADEVENCIMENTO = 'auto-captura/Select/GET_DIADEVENCIMENTO';
export const GET_DIADEVENCIMENTO_SUCCESS =
  'auto-captura/Select/GET_DIADEVENCIMENTO_SUCCESS';
export const GET_DIADEVENCIMENTO_FAIL =
  'auto-captura/Select/GET_DIADEVENCIMENTO_FAIL';
/**
 * Reducer
 */
const initialState = {
  estadosCivis: [],
  ufs: [],
  cidades: [],
  orgaosExpedidores: [],
  profissoes: [],
  parentescos: [],
  tiposProfissoes: [],
  diaDeVencimento: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ESTADOCIVIL_SUCCESS:
      return {
        ...state,
        estadosCivis: action.payload,
      };

    case GET_UF_SUCCESS:
      return {
        ...state,
        ufs: action.payload,
      };

    case GET_CIDADES_SUCCESS: {
      return {
        ...state,
        cidades: action.payload,
      };
    }

    case GET_ORGAOSEXPEDIDORES_SUCCESS: {
      return {
        ...state,
        orgaosExpedidores: action.payload,
      };
    }

    case GET_PROFISSOES_SUCCESS: {
      return {
        ...state,
        profissoes: action.payload,
      };
    }

    case GET_RELACOES_SUCCESS: {
      return {
        ...state,
        parentescos: action.payload,
      };
    }

    case GET_TIPOSPROFISSOES_SUCCESS: {
      return {
        ...state,
        tiposProfissoes: action.payload,
      };
    }

    case GET_DIADEVENCIMENTO_SUCCESS: {
      return {
        ...state,
        diaDeVencimento: action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;

/**
 * Action Creators
 */
const showErrors = (e, service) => {
  if (EnvService.get('ENV') === 'dev') {
    NotificationService.showValidationSingleError(e.problem);
    console.log(`Requisição ${service} com erro :`, e);
  } else
    NotificationService.showValidationSingleError(
      `Não foi possível ${service}. Por favor, tente novamente mais tarde.`,
    );
};

export const estadoCivilBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar estadoCivilBuscar');
    dispatch({type: GET_ESTADOCIVIL});

    const estadosCivis = await AutoCapturaService.getEstadoCivil();

    dispatch({type: GET_ESTADOCIVIL_SUCCESS, payload: estadosCivis});
  } catch (e) {
    dispatch({type: GET_ESTADOCIVIL_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar os estados civis.',
      );
    else showErrors(e, ' buscar os estados civis');
  }
};

export const ufBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar ufBuscar');
    dispatch({type: GET_UF});

    const ufs = await AutoCapturaService.getUfs();

    dispatch({type: GET_UF_SUCCESS, payload: ufs});
  } catch (e) {
    dispatch({type: GET_UF_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar os estados.',
      );
    else showErrors(e, ' buscar os estados');
  }
};

export const cidadesBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar cidadesBuscar');
    dispatch({type: GET_CIDADES});

    const cidades = await AutoCapturaService.getCidades();

    dispatch({type: GET_CIDADES_SUCCESS, payload: cidades});
  } catch (e) {
    dispatch({type: GET_CIDADES_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar as cidades.',
      );
    else showErrors(e, ' buscar as cidades');
  }
};

export const orgaosExpedidoresBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar orgaosExpedidoresBuscar');
    dispatch({type: GET_ORGAOSEXPEDIDORES});

    const orgaosExpedidores = await AutoCapturaService.getOrgaosExpedidores();

    dispatch({
      type: GET_ORGAOSEXPEDIDORES_SUCCESS,
      payload: orgaosExpedidores,
    });

    return orgaosExpedidores;
  } catch (e) {
    dispatch({type: GET_ORGAOSEXPEDIDORES_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar os orgãos expedidores.',
      );
    else showErrors(e, ' buscar as os orgãos expedidores.');
  }
};

export const tiposProfissoesBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar tiposProfissoesBuscar');
    dispatch({type: GET_TIPOSPROFISSOES});

    const tiposProfissoes = await AutoCapturaService.getTipoProfissao();

    dispatch({type: GET_TIPOSPROFISSOES_SUCCESS, payload: tiposProfissoes});
  } catch (e) {
    dispatch({type: GET_TIPOSPROFISSOES_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar os tipos de profissões.',
      );
    else showErrors(e, ' buscar os tipos de profissões.');
  }
};

export const profissoesBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar profissoesBuscar');
    dispatch({type: GET_PROFISSOES});

    const profissoes = await AutoCapturaService.getProfissao();

    dispatch({type: GET_PROFISSOES_SUCCESS, payload: profissoes});
  } catch (e) {
    dispatch({type: GET_PROFISSOES_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar as profissões.',
      );
    else showErrors(e, ' buscar as profissões.');
  }
};

export const relacoesBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar relacoesBuscar');
    dispatch({type: GET_RELACOES});

    const parentescos = await AutoCapturaService.getRelacao();

    dispatch({type: GET_RELACOES_SUCCESS, payload: parentescos});
  } catch (e) {
    dispatch({type: GET_RELACOES_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar as relações.',
      );
    else showErrors(e, ' buscar as relações.');
  }
};

export const diaDeVencimentoBuscar = () => async (dispatch) => {
  try {
    console.log('Iniciar diaDeVencimentoBuscar');
    dispatch({type: GET_DIADEVENCIMENTO});

    const diaDeVencimento = await AutoCapturaService.getDiaDeVencimento();

    dispatch({type: GET_DIADEVENCIMENTO_SUCCESS, payload: diaDeVencimento});
  } catch (e) {
    dispatch({type: GET_DIADEVENCIMENTO_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar os dias de vencimentos.',
      );
    else showErrors(e, ' buscar os dias de vencimento');
  }
};
